import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
    type QuickRegistrationDraft,
    type QuickRegistrationVehicleDraft,
    makeEmptyQuickRegistrationDraft,
    makeEmptyVehicleDraft,
} from '../domain/quickRegistration';

export interface QuickRegistrationSlice {
    draft: QuickRegistrationDraft;
    step: number;
}

const initialState: QuickRegistrationSlice = {
    draft: makeEmptyQuickRegistrationDraft(),
    step: 0,
};

const quickRegistrationSlice = createSlice({
    initialState,
    name: 'quick-registration',
    reducers: {
        addVehicleDraft: (state, action: PayloadAction<string>) => {
            state.draft.vehicles.push(makeEmptyVehicleDraft(action.payload));
        },
        removeVehicleDraft: (state, action: PayloadAction<string>) => {
            state.draft.vehicles = state.draft.vehicles.filter((vehicle) => vehicle.draftId !== action.payload);
        },
        resetQuickRegistration: () => initialState,
        setAdminEmailAt: (state, action: PayloadAction<{ index: number; value: string }>) => {
            state.draft.adminEmails[action.payload.index] = action.payload.value;
        },
        addAdminEmail: (state) => {
            state.draft.adminEmails.push('');
        },
        removeAdminEmailAt: (state, action: PayloadAction<number>) => {
            state.draft.adminEmails.splice(action.payload, 1);
            if (state.draft.adminEmails.length === 0) state.draft.adminEmails.push('');
        },
        setGroupName: (state, action: PayloadAction<string>) => {
            state.draft.groupName = action.payload;
        },
        setStep: (state, action: PayloadAction<number>) => {
            state.step = action.payload;
        },
        updateVehicleDraft: (state, action: PayloadAction<{ draftId: string; changes: Partial<QuickRegistrationVehicleDraft> }>) => {
            const vehicle = state.draft.vehicles.find((item) => item.draftId === action.payload.draftId);
            if (vehicle) Object.assign(vehicle, action.payload.changes);
        },
    },
});

export const {
    addAdminEmail,
    addVehicleDraft,
    removeAdminEmailAt,
    removeVehicleDraft,
    resetQuickRegistration,
    setAdminEmailAt,
    setGroupName,
    setStep,
    updateVehicleDraft,
} = quickRegistrationSlice.actions;
export default quickRegistrationSlice.reducer;
